import { AspectValue } from "../models/EbayOffer";
import normalizeString from "./normaliseString";

//The eBay value a known part field should prefill - an exact match first, then the first value
//containing it. Accents are ignored: eBay has "Citroën" and "Škoda" where the vehicle make has none.
export function matchAspectValue(aspectValues: AspectValue[], lookFor: string): string {
  const target = normalizeString(lookFor);

  //Nothing to look for would "contain" every value and prefill the first one
  if (!target) return "";

  const match = aspectValues.find((value) => normalizeString(value.localizedValue) === target) ??
    aspectValues.find((value) => normalizeString(value.localizedValue)?.includes(target));

  return match?.localizedValue ?? "";
}
